/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {PrettyPrintClosedByPipe} from './pretty-closed-by/pretty-print-closed-by.pipe';
import {PrettyPrintUpdatedByPipe} from '../../../shared/pipes/pretty-print-updated-by/pretty-print-updated-by.pipe';

@NgModule({
    declarations: [
        PrettyPrintClosedByPipe
    ],
    imports: [],
    exports: [
        PrettyPrintClosedByPipe
    ],
    providers: [
        PrettyPrintUpdatedByPipe
    ]
})
export class BundlesPipesModule {
}
